import { safeCombineEpics } from '@cbridge-utils/redux-observable';
import { loadCoverageRuleEpic } from './_epics/loadCoverageRule.epic';
import { updateCoverageRuleEpic } from './_epics/updateCoverageRule.epic';
import { validateCoverageRuleEpic } from './_epics/validateCoverageRule.epic';
import { reloadCoverageRuleEpic } from './_epics/reloadCoverageRule.epic';

export const coverageRuleEpic = safeCombineEpics(
  loadCoverageRuleEpic,
  updateCoverageRuleEpic,
  validateCoverageRuleEpic,
  reloadCoverageRuleEpic,
);
